import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="taasa__cta">
    <div className="taasa__cta-content">
      <p>Early access</p>
      <h3>Do you have a fleet of ambulances? Are you an emergency service provider? </h3>
      <br></br>
      <p>Register today & join the waitlist for our enterpise solution.</p>
    </div>
    <div className="taasa__cta-btn">
    <a href = "https://tally.so/r/nPd7Zd" rel="form">
      <button type="button">Get early access</button>
    </a>
    </div>
  </div>
);

export default CTA;
